export default function formatEventType(eventType) {
  return eventType
    .split(/[._]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
